
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"128","viewBox":"0 0 128 128","width":"128","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61.894 66.056H16.185a2 2 0 010-4h45.709a2 2 0 010 4zM111.907 66.056H87.655a2 2 0 010-4h24.252a2 2 0 010 4zM48.503 96.609H16.185a2 2 0 010-4h32.318a2 2 0 010 4zM111.907 96.609H74.774a2 2 0 010-4h37.133a2 2 0 010 4zM35.013 35.502H16.185a2 2 0 010-4h18.828a2 2 0 010 4zM111.907 35.502H60.776a2 2 0 010-4h51.131a2 2 0 010 4z"}}),_c('path',{attrs:{"d":"M42.616 43.104c-5.295 0-9.604-4.309-9.604-9.604 0-5.295 4.309-9.603 9.604-9.603s9.604 4.308 9.604 9.603c0 5.296-4.309 9.604-9.604 9.604zm0-15.207a5.61 5.61 0 00-5.604 5.603c0 3.09 2.514 5.604 5.604 5.604S48.22 36.59 48.22 33.5a5.61 5.61 0 00-5.604-5.603zM56.106 104.215c-5.295 0-9.604-4.309-9.604-9.605 0-5.295 4.309-9.604 9.604-9.604 5.297 0 9.605 4.309 9.605 9.604.001 5.296-4.308 9.605-9.605 9.605zm0-15.209a5.61 5.61 0 00-5.604 5.604 5.61 5.61 0 005.604 5.605 5.61 5.61 0 005.605-5.605 5.61 5.61 0 00-5.605-5.604zM69.501 73.661c-5.298 0-9.607-4.31-9.607-9.605 0-5.295 4.31-9.604 9.607-9.604 5.294 0 9.602 4.308 9.602 9.604 0 5.296-4.308 9.605-9.602 9.605zm0-15.209a5.612 5.612 0 00-5.607 5.604 5.613 5.613 0 005.607 5.605 5.61 5.61 0 005.602-5.605 5.61 5.61 0 00-5.602-5.604z"}})])
          )
        }
      }
    